<div class="run-details-container">
  <app-page-header></app-page-header>

  <div class="fixed-view-title-row">
    <div class="fixed-view-title-wrap">
      @if (activeTab === 'runs' || activeTab === 'details' || activeTab === 'results') {
        <button
          class="fixed-title-back-btn"
          (click)="activeTab === 'runs' ? goBack() : switchTab('runs')"
          [title]="getBackButtonTooltip()"
          [attr.aria-label]="getBackButtonTooltip()">
          <svg
            class="back-arrow-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true">
            <path d="M19 12H5"></path>
            <path d="M12 19l-7-7 7-7"></path>
          </svg>
        </button>
      }

      <h1 class="fixed-view-title">
        @if (activeTab === 'runs') {
          Runs for model - {{ formatDocumentModelForDisplay(documentModel) }}
        } @else if (activeTab === 'details') {
          Validation Results
        } @else if (activeTab === 'results') {
          Validation Details
        }
      </h1>
    </div>
  </div>

  <!-- Sticky Summary Header - Shows when scrolling -->
  @if (validationRun && showStickyHeader) {
    <div class="sticky-summary-header">
      <div class="sticky-summary-content">
        
        
        <div class="sticky-item">
          <span class="sticky-label">Evaluation ID</span>
          <span class="sticky-value">{{ validationRun.runId }}</span>
        </div>
        
        <div class="sticky-item">
          <span class="sticky-label">Document Model</span>
          <span class="sticky-value">{{ validationRun.documentCode || validationRun.loanNumber || '-' }}</span>
        </div>
        
        <div class="sticky-item">
          <span class="sticky-label">Started</span>
          <span class="sticky-value">{{ (validationRun.createdDate | date:'MMM d, h:mm a') || '—' }}</span>
        </div>
        
        <div class="sticky-item">
          <span class="sticky-label">Status</span>
          <span class="status-badge" [class.completed]="validationRun.status === 'Completed'" [class.in-progress]="validationRun.status === 'In Progress'" [class.failed]="validationRun.status === 'Failed'" [class.pending]="validationRun.status === 'Pending'">
            {{ validationRun.status }}
          </span>
        </div>
        
        <div class="sticky-accuracy">
          <span class="sticky-accuracy-value">{{ validationRun.accuracy | number:'1.2-2' }}%</span>
          <span class="sticky-accuracy-label">Accuracy</span>
        </div>
      </div>
    </div>
  }

  <!-- Tab Content - Runs tab loads independently, other tabs require validationRun -->
  <div class="tab-content" #tabContent (scroll)="onTabContentScroll($event)">
    
    <!-- Runs Tab - Can load independently using documentModel -->
    @if (activeTab === 'runs') {
      @if (documentModel) {
        <app-evaluation-runs [documentModel]="documentModel" [isEmbedded]="true" (evaluationSelected)="onEvaluationSelected($event)" (evaluationStatusChanged)="onEvaluationStatusChanged($event)" (latestRunsLoaded)="onLatestRunsLoaded($event)"></app-evaluation-runs>
      } @else {
        <div class="page-loading-state">
          <div class="docsila-loader">
            <div class="beat-loader">
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
            </div>
            <p class="loader-text">Loading evaluation runs...</p>
          </div>
        </div>
      }
    }
    
    <!-- Validation Views - Requires validationRun -->
    @if (activeTab === 'details' || activeTab === 'results') {
      @if (validationRun) {
        @if (isEvaluationRunning()) {
          <div class="page-loading-state evaluation-running-centered" role="status" aria-live="polite">
            <div class="docsila-loader">
              <div class="beat-loader">
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
              </div>
            </div>
          </div>
        } @else {
          <div class="unified-eval-card" #runSummarySection>
            <div class="eval-header">
              <span class="eval-badge completed">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Run Summary
              </span>
              <span class="eval-id" (click)="startEvaluationEdit()" style="cursor: pointer;" title="Click to change evaluation">
                ID: {{ getEvaluationId() }}
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-left: 4px; opacity: 0.7;">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                </svg>
              </span>
            </div>

            @if (editingEvaluationId) {
              <div class="eval-id-edit-row">
                <input
                  type="text"
                  class="eval-id-input"
                  [class.invalid]="evaluationIdInput && evaluationIdInput.length > 0 && !isValidEvaluationId()"
                  [(ngModel)]="evaluationIdInput"
                  (keypress)="onKeyPress($event)"
                  (paste)="onPaste($event)"
                  (ngModelChange)="onEvaluationIdChange($event)"
                  (keydown.enter)="isValidEvaluationId() && loadEvaluationById()"
                  (keydown.escape)="cancelEvaluationEdit()"
                  placeholder="Enter GUID format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                  maxlength="36"
                  autofocus>
                <button
                  class="eval-action-btn"
                  (click)="loadEvaluationById()"
                  title="Load"
                  [disabled]="!isValidEvaluationId()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </button>
                <button class="eval-action-btn cancel" (click)="cancelEvaluationEdit()" title="Cancel">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            }

            @if (evaluationError) {
              <div class="eval-error-message">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <span>{{ evaluationError }}</span>
                <button class="error-dismiss-btn" (click)="evaluationError = null">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            }

            <div class="eval-content">
              <div class="metric-circle-section">
                <div class="accuracy-display">
                  <div class="accuracy-circle">
                    <svg viewBox="0 0 36 36" class="circular-chart accuracy">
                      <circle cx="18" cy="18" r="14" fill="none" stroke="rgba(255,255,255,0.2)" stroke-width="4" pathLength="100"/>
                      <circle cx="18" cy="18" r="14" fill="none" stroke="#ffffff" stroke-width="4" pathLength="100"
                        [attr.stroke-dasharray]="(runSummary.overallAccuracy) + ' 100'"
                        stroke-dashoffset="0" transform="rotate(-90 18 18)"/>
                    </svg>
                    <span class="accuracy-value">{{ runSummary.overallAccuracy | number:'1.0-0' }}%</span>
                  </div>
                  <span class="accuracy-label">Accuracy</span>
                </div>
              </div>

              <div class="details-inline-section">
                <div class="inline-details-row">
                  <span class="inline-detail-item">
                    <span class="inline-detail-label">Document Model</span>
                    <span class="inline-detail-value document-model-value" [title]="validationRun.documentCode || '-'">
                      {{ validationRun.documentCode || '-' }}
                    </span>
                  </span>
                  <span class="inline-detail-item">
                    <span class="inline-detail-label">Status</span>
                    <span class="inline-detail-value status-badge-inline" [class.completed]="validationRun.status === 'COMPLETED' || validationRun.status === 'Completed'" [class.failed]="validationRun.status === 'FAILED' || validationRun.status === 'Failed'" [class.running]="validationRun.status === 'RUNNING' || validationRun.status === 'In Progress'" [class.pending]="validationRun.status === 'PENDING' || validationRun.status === 'Pending'">
                      {{ validationRun.status || 'COMPLETED' }}
                    </span>
                  </span>
                  <span class="inline-detail-item">
                    <span class="inline-detail-label">Started</span>
                    <span class="inline-detail-value">{{ (validationRun.createdDate | date:'MMM d, hh:mm a') || '—' }}</span>
                  </span>
                  <span class="inline-detail-item">
                    <span class="inline-detail-label">Duration</span>
                    <span class="inline-detail-value">{{ isEvaluationRunning() ? (currentTimer$ | async) || '—' : validationRun.duration || '—' }}</span>
                  </span>
                  <span class="inline-detail-item">
                    <span class="inline-detail-label">OCR Mode</span>
                    <span class="inline-detail-value">{{ validationRun.ocrMode || '—' }}</span>
                  </span>
                  <span class="inline-detail-item">
                    <span class="inline-detail-label">LLM Model</span>
                    <span class="inline-detail-value">{{ validationRun.llmModel || '—' }}</span>
                  </span>
                </div>
              </div>

              <div class="bar-chart-section">
                <div class="bar-chart-card">
                  <span class="bar-chart-title">Field Status</span>
                  <svg viewBox="0 0 100 20" class="horizontal-bar-chart" style="width: 12rem;" aria-label="Matched and Unmatched fields">
                    <rect x="0" y="5" width="100" height="10" rx="5" fill="rgba(255,255,255,0.22)" />
                    @if (getSummaryMatchedPercent() >= 100) {
                      <rect x="0" y="5" width="100" height="10" rx="5" fill="#cfe9f3" />
                    } @else if (getSummaryMatchedPercent() <= 0) {
                      <rect x="0" y="5" width="100" height="10" rx="5" fill="#ffccdd" />
                    } @else {
                      <path [attr.d]="'M 5 5 L ' + getSummaryMatchedPercent() + ' 5 L ' + getSummaryMatchedPercent() + ' 15 L 5 15 A 5 5 0 0 1 0 10 A 5 5 0 0 1 5 5 Z'" fill="#cfe9f3" />
                      <path [attr.d]="'M ' + getSummaryMatchedPercent() + ' 5 L 95 5 A 5 5 0 0 1 100 10 A 5 5 0 0 1 95 15 L ' + getSummaryMatchedPercent() + ' 15 Z'" fill="#ffccdd" />
                    }
                  </svg>
                  <span class="bar-chart-label" style="font-size: 0.75rem; color: white;">{{ getSummaryMatchedFields() }} matched<br />{{ getSummaryUnmatchedFields() }} unmatched</span>
                </div>
              </div>

              <div class="pie-section">
                <div class="file-status-chart">
                  <div class="pie-chart-mini">
                    <svg viewBox="0 0 36 36" class="circular-chart">
                      <circle cx="18" cy="18" r="9" fill="none" stroke="rgba(255,255,255,0.2)" stroke-width="18" pathLength="100"/>
                      <circle cx="18" cy="18" r="9" fill="none" stroke="#eff6ff" stroke-width="18" pathLength="100"
                        [attr.stroke-dasharray]="getFileStatusDashArray('completed')"
                        stroke-dashoffset="0" transform="rotate(-90 18 18)"/>
                      <circle cx="18" cy="18" r="9" fill="none" stroke="#22c55e" stroke-width="18" pathLength="100"
                        [attr.stroke-dasharray]="getFileStatusDashArray('running')"
                        [attr.stroke-dashoffset]="'-' + getFileStatusOffset('running')" transform="rotate(-90 18 18)"/>
                      <circle cx="18" cy="18" r="9" fill="none" stroke="#ef4444" stroke-width="18" pathLength="100"
                        [attr.stroke-dasharray]="getFileStatusDashArray('failed')"
                        [attr.stroke-dashoffset]="'-' + getFileStatusOffset('failed')" transform="rotate(-90 18 18)"/>
                      <circle cx="18" cy="18" r="9" fill="none" stroke="#9ca3af" stroke-width="18" pathLength="100"
                        [attr.stroke-dasharray]="getFileStatusDashArray('pending')"
                        [attr.stroke-dashoffset]="'-' + getFileStatusOffset('pending')" transform="rotate(-90 18 18)"/>
                    </svg>
                  </div>
                  <div class="chart-legend">
                    <span class="legend-item"><span class="dot completed"></span><span class="legend-label">Success</span><span class="legend-count">{{ evaluationStatus?.completed_files || runSummary.processedFiles }}</span></span>
                    @if ((evaluationStatus?.running_files || 0) > 0) {
                      <span class="legend-item"><span class="dot running"></span><span class="legend-label">In Progress</span><span class="legend-count">{{ evaluationStatus?.running_files }}</span></span>
                    }
                    @if ((evaluationStatus?.failed_files || 0) > 0) {
                      <span class="legend-item"><span class="dot failed"></span><span class="legend-label">Failed</span><span class="legend-count">{{ evaluationStatus?.failed_files }}</span></span>
                    }
                    @if ((evaluationStatus?.pending_files || 0) > 0) {
                      <span class="legend-item"><span class="dot pending"></span><span class="legend-label">Pending</span><span class="legend-count">{{ evaluationStatus?.pending_files }}</span></span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="details-section" [class.with-sticky-summary]="showStickyHeader">
            <div class="section-header" [class.with-sticky-summary]="showStickyHeader">
              <div class="matrix-view-toggle" aria-label="Validation views">
                <button class="matrix-view-btn" [class.active]="activeTab === 'details'" (click)="switchTab('details')" type="button">
                  Validation Results
                </button>
                <button class="matrix-view-btn" [class.active]="activeTab === 'results'" (click)="switchTab('results')" type="button">
                  Validation Details
                </button>
              </div>
            </div>

            @if (activeTab === 'details') {
              <div class="matrix-wrapper">
                @if (loadingMatrix) {
                  <div class="matrix-loading-overlay">
                    <div class="matrix-skeleton">
                      @for (row of [1,2,3,4,5]; track row) {
                        <div class="skeleton-row">
                          <div class="skeleton-cell file-cell"></div>
                          @for (col of [1,2,3,4,5,6,7,8]; track col) {
                            <div class="skeleton-cell data-cell"></div>
                          }
                          <div class="skeleton-cell accuracy-cell"></div>
                        </div>
                      }
                    </div>
                  </div>
                } @else if (isEvaluationRunning()) {
                  <div class="empty-state">
                    <p>Evaluation in progress. Validation matrix will appear after completion.</p>
                  </div>
                } @else if (evaluationStatus?.status === 'FAILED' || (validationRun && (validationRun.status === 'FAILED' || validationRun.status === 'Failed'))) {
                  <div class="empty-state">
                    <p style="font-style: italic !important; color: var(--text-secondary) !important; font-size: 1rem !important;">No details to show</p>
                  </div>
                } @else if (validationRun && (validationRun.status === 'COMPLETED' || validationRun.status === 'Completed') && matrixData && matrixData.length > 0) {
                  <table class="validation-matrix">
                    <thead>
                      <tr>
                        <th class="file-column">File Name</th>
                        @for (attr of matrixAttributes; track attr) {
                          @if (shouldDisplayField(attr)) {
                            <th class="attr-column">
                              <span class="attr-label-text" [title]="formatFieldName(attr)">{{ formatFieldName(attr) }}</span>
                              @if (isMatrixFieldArray(attr)) {
                                <span class="attr-type-indicator array" [title]="getMatrixFieldTypeLabel(attr)">
                                  {{ getMatrixFieldTypeIndicator(attr) }}
                                </span>
                              }
                            </th>
                          }
                        }
                        <th class="accuracy-column">Accuracy</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (file of matrixData; track $index) {
                        <tr>
                          <td class="file-name" 
                              [class.failed]="file.isFailed" 
                              [title]="file.isFailed ? getCleanFileName(file.fileName) + ' (Processing Failed)' : getCleanFileName(file.fileName)">
                            <span class="file-name-text">{{ getCleanFileName(file.fileName) }}</span>
                            @if (authService.isAdmin) {
                              @if (isFileActionEnabled(file)) {
                                <button
                                  class="file-level-tuning-btn"
                                  type="button"
                                  title="Click to train"
                                  (click)="navigateToPromptTuningForFile(file, $event)">
                                  T
                                </button>
                              } @else if (isFileSuccessIndicatorVisible(file)) {
                                <span class="file-level-success-indicator" title="All fields matched">✓</span>
                              }
                            }
                          </td>
                          @for (attr of matrixAttributes; track attr) {
                            @if (shouldDisplayField(attr)) {
                              <td class="validation-cell"
                                [class.match]="file.attributes[attr] === 'Y'"
                                [class.mismatch]="file.attributes[attr] === 'N'"
                                [class.unknown]="file.attributes[attr] === '-' || !file.attributes[attr]">
                                @if (file.attributes[attr] === 'Y') {
                                  <svg class="validation-icon match-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                  </svg>
                                } @else if (file.attributes[attr] === 'N') {
                                  <svg class="validation-icon mismatch-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                  </svg>
                                }
                              </td>
                            }
                          }
                          <td class="accuracy-value">
                            @if (file.isFailed) {
                              0.00%
                            } @else {
                              {{ file.accuracy | number:'1.2-2' }}%
                            }
                          </td>
                        </tr>
                      }
                      <tr class="accuracy-row">
                        <td class="accuracy-label">Accuracy</td>
                        @for (attr of matrixAttributes; track attr) {
                          @if (shouldDisplayField(attr)) {
                            <td class="attr-accuracy">
                              <span class="attr-accuracy-value">{{ attributeAccuracy[attr] | number:'1.0-0' }}%</span>
                            </td>
                          }
                        }
                        <td class="overall-accuracy">{{ overallAccuracy | number:'1.2-2' }}%</td>
                      </tr>
                    </tbody>
                  </table>
                } @else {
                  <div class="empty-state">
                    <p style="font-style: italic !important; color: var(--text-secondary) !important; font-size: 1rem !important;">Loading validation data...</p>
                  </div>
                }
              </div>

              @if (tooltipVisible) {
                <div class="custom-tooltip" [style.left.px]="tooltipX" [style.top.px]="tooltipY">
                  <div class="tooltip-content">{{ tooltipContent }}</div>
                </div>
              }
            } @else {
              <div class="results-section full-width">
                <div class="results-layout">
                  <div class="results-content full-width">
                    <div class="filter-bar">
                      <div class="filter-group">
                        <input
                          type="text"
                          [(ngModel)]="fileNameFilter"
                          (input)="applyFilter()"
                          (paste)="onPasteFilterInput($event, 'fileNameFilter')"
                          placeholder="Filter by file name..."
                          class="filter-input">
                      </div>
                      <div class="filter-group">
                        <input
                          type="text"
                          [(ngModel)]="fieldFilter"
                          (input)="applyFilter()"
                          (paste)="onPasteFilterInput($event, 'fieldFilter')"
                          placeholder="Filter by field..."
                          class="filter-input">
                      </div>
                      <div class="filter-group">
                        <input
                          type="text"
                          [(ngModel)]="expectedValueFilter"
                          (input)="applyFilter()"
                          (paste)="onPasteFilterInput($event, 'expectedValueFilter')"
                          placeholder="Filter by expected value..."
                          class="filter-input">
                      </div>
                      <div class="filter-group">
                        <input
                          type="text"
                          [(ngModel)]="actualValueFilter"
                          (input)="applyFilter()"
                          (paste)="onPasteFilterInput($event, 'actualValueFilter')"
                          placeholder="Filter by actual value..."
                          class="filter-input">
                      </div>
                      <div class="filter-group">
                        <select
                          [(ngModel)]="matchFilter"
                          (change)="applyFilter()"
                          class="filter-select">
                          <option value="all">All</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </select>
                      </div>
                      <div class="filter-actions">
                        <button class="btn-clear-filters" (click)="clearFilter()">
                          Clear Filters
                        </button>
                      </div>
                    </div>

                    <div class="details-table-wrapper">
                      @if (loadingValidationDetails) {
                        <div class="page-loading-state compact">
                          <div class="docsila-loader">
                            <div class="beat-loader">
                              <div class="beat"></div>
                              <div class="beat"></div>
                              <div class="beat"></div>
                              <div class="beat"></div>
                              <div class="beat"></div>
                            </div>
                            <p class="loader-text">Loading validation details from evaluation...</p>
                          </div>
                        </div>
                      } @else {
                        <table class="details-table">
                          <thead>
                            <tr>
                              <th class="sortable" (click)="sortDetailsBy('fileName')">
                                File Name <span class="sort-icon" [innerHTML]="getDetailsSortIcon('fileName')"></span>
                              </th>
                              <th class="sortable" (click)="sortDetailsBy('field')">
                                Field <span class="sort-icon" [innerHTML]="getDetailsSortIcon('field')"></span>
                              </th>
                              <th class="sortable" (click)="sortDetailsBy('expectedValue')">
                                Expected Value <span class="sort-icon" [innerHTML]="getDetailsSortIcon('expectedValue')"></span>
                              </th>
                              <th class="sortable" (click)="sortDetailsBy('actualValue')">
                                Actual Value <span class="sort-icon" [innerHTML]="getDetailsSortIcon('actualValue')"></span>
                              </th>
                              <th class="sortable" (click)="sortDetailsBy('match')">
                                Match <span class="sort-icon" [innerHTML]="getDetailsSortIcon('match')"></span>
                              </th>
                              <th class="sortable" (click)="sortDetailsBy('confidence')">
                                Confidence <span class="sort-icon" [innerHTML]="getDetailsSortIcon('confidence')"></span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (detail of filteredDetails; track $index) {
                              @if (shouldDisplayField(detail.field)) {
                                <tr [class.mismatch]="!detail.match">
                                  <td>
                                    <div class="file-cell" [title]="detail.fileName">
                                      {{ getShortFileName(detail.fileName) }}
                                    </div>
                                  </td>
                                  <td>
                                    <div class="field-cell" [title]="formatFieldName(detail.field)">
                                      <span class="field-name-text">{{ formatFieldName(detail.field) }}</span>
                                      @if (detail.isTableField) {
                                        <button
                                          class="table-eye-btn"
                                          type="button"
                                          (click)="openTableComparisonModal(detail)"
                                          [title]="'View table: ' + formatFieldName(detail.field)">
                                          <svg class="eye-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                            <circle cx="12" cy="12" r="3"></circle>
                                          </svg>
                                        </button>
                                      }
                                    </div>
                                  </td>
                                <td>
  <div class="value-cell expected">
    @if (detail.isTableField) {
      <span class="table-badge">{{ detail.expectedValue }}</span>
    } @else if (detail.expectedValueArray && detail.expectedValueArray.length > 0) {
      @for (value of detail.expectedValueArray; track $index) {
        <div class="value-item">{{ value }}</div>
      }
    } @else {
      <div class="value-item">{{ detail.expectedValue }}</div>
    }
  </div>
</td>
<td>
  <div class="value-cell actual">
    @if (detail.isTableField) {
      <span class="table-badge">{{ detail.actualValue }}</span>
    } @else if (detail.actualValueArray && detail.actualValueArray.length > 0) {
      @for (value of detail.actualValueArray; track $index) {
        <div class="value-item">{{ value }}</div>
      }
    } @else {
      <div class="value-item">{{ detail.actualValue }}</div>
    }
  </div>
</td>
                                <td>
                                  @if (detail.match) {
                                    <span class="match-badge success">Match</span>
                                  } @else {
                                    <span class="match-badge mismatch">Mismatch</span>
                                  }
                                </td>
                                <td>
                                  <div class="confidence-cell">
                                    <div class="confidence-bar">
                                      <div
                                        class="confidence-fill"
                                        [style.width.%]="detail.confidence"
                                        [class.high]="detail.confidence >= 90"
                                        [class.medium]="detail.confidence >= 70 && detail.confidence < 90"
                                        [class.low]="detail.confidence < 70">
                                      </div>
                                    </div>
                                    <span class="confidence-text">{{ detail.confidence | number:'1.0-0' }}%</span>
                                  </div>
                                </td>
                              </tr>
                              }
                            } @empty {
                              <tr>
                                <td colspan="6" class="empty-row">
                                  @if (validationRun.status === 'FAILED' || validationRun.status === 'Failed') {
                                    No details to show
                                  } @else if (isEvaluationRunning()) {
                                    Evaluation is in progress for ID {{ getEvaluationId() }}. Validation rows will appear as files complete{{ fileNameFilter ? ' and match the current filter' : '' }}.
                                  } @else {
                                    No validation results found{{ fileNameFilter ? ' for the current filter' : '' }}
                                  }
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      } @else {
        <div class="page-loading-state">
          <div class="docsila-loader">
            <div class="beat-loader">
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
            </div>
            <p class="loader-text">Loading validation results...</p>
          </div>
        </div>
      }
    }

  </div>

  @if (tableModalDetail) {
    <div class="modal-overlay" (click)="closeTableComparisonModal()">
      <div class="modal-dialog table-comparison-dialog" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h2>{{ formatFieldName(tableModalDetail.field) }}</h2>
          <button class="close-btn" (click)="closeTableComparisonModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body table-comparison-body">
          <div class="table-comparison-panel">
            <h3>Expected (Ground Truth)</h3>
            @if (tableModalDetail.expectedTable && tableModalDetail.expectedTable.rows.length > 0) {
              <div class="table-wrapper">
                <table class="extracted-table">
                  <thead>
                    <tr>
                      @for (column of tableModalDetail.expectedTable.columns; track column) {
                        <th class="table-header-cell">{{ column }}</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (row of tableModalDetail.expectedTable.rows; track $index) {
                      <tr class="table-row">
                        @for (column of tableModalDetail.expectedTable.columns; track column) {
                          <td class="table-cell" [class.empty-cell]="!row[column]">{{ row[column] || '—' }}</td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            } @else {
              <div class="field-empty-box">No ground truth rows</div>
            }
          </div>

          <div class="table-comparison-panel">
            <h3>Actual (Extracted)</h3>
            @if (tableModalDetail.actualTable && tableModalDetail.actualTable.rows.length > 0) {
              <div class="table-wrapper">
                <table class="extracted-table">
                  <thead>
                    <tr>
                      @for (column of tableModalDetail.actualTable.columns; track column) {
                        <th class="table-header-cell">{{ column }}</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (row of tableModalDetail.actualTable.rows; track $index) {
                      <tr class="table-row">
                        @for (column of tableModalDetail.actualTable.columns; track column) {
                          <td class="table-cell" [class.empty-cell]="!row[column]">{{ row[column] || '—' }}</td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            } @else {
              <div class="field-empty-box">No extracted rows</div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>

